import { Injectable } from '@angular/core';
import { ForumService } from '@fi-app/forum/forum.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { PostModel } from '@fi-shared/models';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters/access-right-filters.component';
import { PostService } from '@fi-shared/fi-shared-services';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { TextEditorTagUsersService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-tag-users.service';

@Injectable()
export class NewsFeedModuleService {
    constructor(
        private forumService: ForumService,
        private postService: PostService,
        private fiLoadingService: LoadingService,
        private contentLanguageSharedService: FiContentLanguageSharedService,
        private textEditorTagUsersService: TextEditorTagUsersService,
        private userDataService: FiUserDataService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    GetNameValue(names: any[], field?: string) {
        if (!field) field = 'Name';

        let name = '',
            defaultName = '',
            notEmptyName = '';

        (names || []).forEach((item) => {
            if (name.length > 0 && defaultName.length > 0) return;

            if (item.ContentLanguageId == this.userDataService.userData.PreferredContentLanguage) {
                name = this.GetTrimmedValue(item[field]);
            } else if (item.ContentLanguageId == this.contentLanguageSharedService.getDefaultContentLanguageId()) {
                defaultName = this.GetTrimmedValue(item[field]);
            } else {
                if (!notEmptyName) notEmptyName = this.GetTrimmedValue(item[field]);
            }
        });

        return name.length > 0 ? name : defaultName.length > 0 ? defaultName : notEmptyName;
    }

    GetTrimmedValue(value) {
        let trimmedValue = '';
        if (value && value.length > 0) trimmedValue = value.replace(/^\s+|\s+$/gm, '');

        return trimmedValue;
    }

    savePost(EditorPost: PostModel, accessRightFilters: AccessRightFiltersComponent): Promise<PostModel> {
        const isForumPost = EditorPost.IsForumPost;

        if (accessRightFilters) accessRightFilters.OnAccessRightFilterCollectionSaving();

        const isAccessRightFilterCollectionValid = accessRightFilters
            ? accessRightFilters.validateAccessRightFilterCollection()
            : true;

        if (!isAccessRightFilterCollectionValid) return Promise.reject(false);

        const savePost = new PostModel(this.fiFormatDateService, EditorPost, isForumPost);
        savePost.Content = this.textEditorTagUsersService.getConvertedFromEditToViewModeUserTags(savePost.Content);
        if (isForumPost) savePost.Title = '';

        savePost.Content = this.removeStyleAttributesFromContent(savePost.Content);

        const savePostPromise = isForumPost
            ? this.forumService.saveForumPost(<any>savePost)
            : this.postService.Save(savePost);

        return this.fiLoadingService.trackPromise(savePostPromise).then((postId: number) => {
            if (accessRightFilters) accessRightFilters.OnAccessRightFilterCollectionSaved();

            savePost.Id = postId;
            return savePost;
        });
    }

    private removeStyleAttributesFromContent(content: string): string {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = content;
        const elementsWithStyle = tempContainer.querySelectorAll('[style]');
        elementsWithStyle.forEach((element) => {
            element.removeAttribute('style');
        });
        return tempContainer.innerHTML;
    }
}
